/* ============================================
   Animated Stats Circle - JavaScript
   Shopify Theme Asset
   ============================================ */

/**
 * Initialize the Stats Circle Animation
 * @param {string} sectionId - The unique section ID
 */
function initStatsCircleAnimation(sectionId) {
  const section = document.getElementById(`stats-circle-${sectionId}`);
  if (!section) return;

  const stage = section.querySelector('.stats-stage');
  if (!stage) return;

  // Configuration
  const config = {
    threshold: 0.3, // % of element visible to trigger
    rootMargin: '0px 0px -100px 0px'
  };

  // Intersection Observer for scroll-based animation
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        stage.classList.add('animate-active');
        // Optional: unobserve after animation triggers once
        // observer.unobserve(entry.target);
      } else {
        // Optional: remove class when out of view for re-animation
        // stage.classList.remove('animate-active');
      }
    });
  }, config);

  observer.observe(stage);

  // Advanced: Scroll-based ellipse to circle transform
  initEllipseTransform(section, stage);

  // Initialize hover interactions
  initStatHoverEffects(section);
}

/**
 * Advanced scroll-based ellipse to circle transformation
 * Walters Coffee custom effect
 */
function initEllipseTransform(section, stage) {
  const circleBorder = stage.querySelector('.circle-border');
  if (!circleBorder) return;

  // Enable advanced transform mode
  stage.setAttribute('data-transform-circle', 'true');

  let ticking = false;
  
  function updateCircleTransform() {
    const rect = section.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    
    // Calculate scroll progress (0 to 1)
    const scrollStart = windowHeight;
    const scrollEnd = -rect.height;
    const scrollRange = scrollStart - scrollEnd;
    const scrollPosition = scrollStart - rect.top;
    const progress = Math.max(0, Math.min(1, scrollPosition / scrollRange));

    // Transform values
    // Start: ellipse (scaleY: 0.4, scaleX: 1.8)
    // End: circle (scale: 1)
    const scaleX = 1.8 - (0.8 * progress);
    const scaleY = 0.4 + (0.6 * progress);
    
    // Apply transform
    circleBorder.style.transform = `scale(${scaleX}, ${scaleY})`;
    circleBorder.style.opacity = Math.min(1, progress * 2);

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(updateCircleTransform);
      ticking = true;
    }
  }

  // Initial call
  updateCircleTransform();

  // Listen for scroll
  window.addEventListener('scroll', onScroll, { passive: true });

  // Cleanup on section removal (for theme editor)
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:unload', (e) => {
      if (e.detail.sectionId === section.id.replace('stats-circle-', '')) {
        window.removeEventListener('scroll', onScroll);
      }
    });
  }
}

/**
 * Initialize hover effects for stat items
 */
function initStatHoverEffects(section) {
  const stats = section.querySelectorAll('.a-stat');
  const circleContent = section.querySelector('.circle-content');
  const originalContent = circleContent ? circleContent.innerHTML : '';

  stats.forEach(stat => {
    const popupContent = stat.dataset.popupContent;
    
    stat.addEventListener('mouseenter', () => {
      // Add active class
      stats.forEach(s => s.classList.remove('stat-active'));
      stat.classList.add('stat-active');

      // Update circle content if popup content exists
      if (popupContent && circleContent) {
        circleContent.innerHTML = `
          <div class="popup-content">
            ${popupContent}
          </div>
        `;
      }
    });

    stat.addEventListener('mouseleave', () => {
      stat.classList.remove('stat-active');
      
      // Restore original content
      if (circleContent) {
        circleContent.innerHTML = originalContent;
      }
    });

    // Click to show modal (optional)
    stat.addEventListener('click', () => {
      const statId = stat.dataset.statId;
      // Trigger custom event for modal display
      section.dispatchEvent(new CustomEvent('stat-click', {
        detail: { statId, stat }
      }));
    });
  });
}

/**
 * Alternative: Pure CSS scroll-driven animation
 * For browsers that support scroll-driven animations
 */
function initScrollDrivenAnimation(section) {
  if (!CSS.supports('animation-timeline', 'scroll()')) {
    return false; // Fallback to JS-based animation
  }

  const stage = section.querySelector('.stats-stage');
  stage.style.animationTimeline = 'scroll()';
  stage.style.animationRange = 'entry 0% cover 50%';

  return true;
}

// Auto-initialize on DOM ready (fallback if inline script fails)
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.stats-circle-section');
  sections.forEach(section => {
    const sectionId = section.id.replace('stats-circle-', '');
    if (!section.dataset.initialized) {
      initStatsCircleAnimation(sectionId);
      section.dataset.initialized = 'true';
    }
  });
});

// Reinitialize on Shopify section events (for theme editor)
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.stats-circle-section');
    if (section) {
      const sectionId = section.id.replace('stats-circle-', '');
      initStatsCircleAnimation(sectionId);
    }
  });

  document.addEventListener('shopify:section:reorder', () => {
    document.querySelectorAll('.stats-circle-section').forEach(section => {
      const sectionId = section.id.replace('stats-circle-', '');
      initStatsCircleAnimation(sectionId);
    });
  });
}

// Export for module usage
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { initStatsCircleAnimation };
}
